import { config } from "../env";
import { Delete, get, getWithToken, patch, post } from "./helpers/http-handler";

export const adminGetRolesListPermissions = () =>
  get(`${config.API_URL}/roles/list/permissions`);

export const adminGetRolesListPermissionsNew = () =>
  get(`${config.API_URL}/roles/list/mock/permissions`);

export const adminCreateRole = (payload: object) =>
  post(`${config.API_URL}/roles`, payload);

export const adminGetRoles = (queryRequest: string) =>
  get(`${config.API_URL}/roles?${queryRequest}`);

export const adminGetAllRoles = () => get(`${config.API_URL}/roles`);

export const adminGetSpecificRole = (id: string) =>
  get(`${config.API_URL}/roles/${id}`);

export const adminUpdateSpecificRole = (id: string, payload: object) =>
  patch(`${config.API_URL}/roles/${id}`, payload);

export const adminDeleteSpecificRole = (id: string) =>
  Delete(`${config.API_URL}/roles/${id}`);

export const adminBulkRoleUpdateStatus = (payload: object) =>
  patch(`${config.API_URL}/roles/bulk/active-inactive`, payload);

export const getAllPermissions = () =>
  get(`${config.API_URL}/users/list/permissions`);

export const getAllPermissionsWithToken = (token:string) =>
  getWithToken(`${config.API_URL}/users/list/permissions`,token);

export const getAllPermissionsNew = () =>
  get(`${config.API_URL}/users/list/mock/permissions`);

export const refreshCertificateMV = () =>
  get(`${config.API_URL}/certificate/refresh/mv`);
